import { api } from "@/lib/api";
import {
  CreatePayment,
  createPaymentToDto,
  Payment,
  PaymentDtoSchema,
  paymentFromDto,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getPaymentsQueryOptions } from "./get.hooks";

export function useCreatePayment(opts?: {
  onSuccess?: (payment: Payment) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (payment: CreatePayment) => {
      const dto = createPaymentToDto(payment);
      const result = await api.post("/api/payments", dto, PaymentDtoSchema);
      return paymentFromDto(result);
    },
    onSuccess: (payment) => {
      queryClient.setQueryData(
        getPaymentsQueryOptions(payment.reservationId?.toString() ?? "")
          .queryKey,
        (old) => [...(old ?? []), payment],
      );
      toast({
        title: "toast.paymentCreated",
        variant: "success",
      });
      opts?.onSuccess?.(payment);
    },
    onError: () => {
      toast({
        title: "toast.createPaymentError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
